export const statusEnum = {
  1: "待审核",
  3: "跟进中",
  5: "待买家确认",
  6: "待签署",
  7: "待付款",
  9: "待完成",
  // 80: "发货中",
  100: "完成",
  110: "失效"
};

export const statusEnumList = (() => {
  let list = [
    {
      key: "",
      value: "全部"
    }
  ];
  Object.keys(statusEnum).forEach(key => {
    list.push({
      key: key,
      value: statusEnum[key]
    });
  });
  return list;
})();

export const statusDetail = {
  1: {
    label: "订单待审核",
    color: "#ABABAB"
  },
  3: {
    label: "业务员跟进中",
    color: "#039DF8"
  },
  6: {
    label: "订单待签署",
    color: "#039DF8"
  },
  7: {
    label: "订单已确认，请及时付款",
    color: "#039DF8"
  },
  9: {
    label: "订单待完成",
    color: "#ABABAB"
  },
  // 80: {
  //   label: "发货中",
  //   color: "#ABABAB"
  // },
  100: {
    label: "订单已完成",
    color: "#ABABAB"
  },
  110: {
    label: "失效",
    color: "#ABABAB"
  }
};
